import { useEffect, useState } from "react";

const WINDOW_RESIZE_EVENT = "resize";

interface ReturnProps {
  readonly width: number;
  readonly height: number;
}

export function useWindowSize(): ReturnProps {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  function listenerHandler() {
    setWidth(this.innerWidth);
    setHeight(this.innerHeight);
  }

  useEffect(() => {
    window.addEventListener(WINDOW_RESIZE_EVENT, listenerHandler);

    return () => {
      window.removeEventListener(WINDOW_RESIZE_EVENT, listenerHandler);
    };
  }, []);

  return { width, height };
}
